import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useCreateDeclarationTemplateLotMutation(params?: HydraMutationParams) {
  return useHydraMutation('api/declaration_template_lots', params);
}
